import React from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import Popup from '../../../../Shared/Popup/PopUp';
import {isMobile} from 'react-device-detect';
import { goToPage, reportAnalytics } from '../../TechnicianUpdatesBlockSlice';

const ErrorPopUp = (props) =>  {
    let title = "";
    let explanation1 = "";

    switch(props.errorPopup.type){
      case "TECHNICIAN_UPDATE_TIME_ERROR": //can't update visit Less then 12 hours
          title = "לא ניתן לעדכן מועד זה באתר";
          explanation1 = "לא ניתן לבצע עדכון בטווח של 12 שעות לפני המועד המתואם.";
          props.reportAnalytics({eventCategory: 'technician_update', eventAction: "visibility_4", eventLabel: "element_4"});
          break;
      case "TECHNICIAN_UPDATE_TIME_SLOT_UNAVAILABLE_ERROR":
        title = "לא ניתן לעדכן מועד זה באתר";
          explanation1 = "מישו תפס את המועד שבחרת.";
          props.reportAnalytics({eventCategory: 'technician_update', eventAction: "visibility_7", eventLabel: "element_8"});
          break;
      case "TECHNICIAN_UPDATE_GENERAL_ERROR": 
        title ="המועד לא מעודכן";
        explanation1 = "מצטערים, אירעה שגיאה אנא נסו שנית במועד מאוחר יותר.";
        props.reportAnalytics({eventCategory: 'technician_update', eventAction: "visibility_9", eventLabel: "element_10"});
        break;
      case "TECHNICIAN_UPDATE_GENERAL_2_ERROR": 
        title ="לא ניתן לעדכן את המועד";
        explanation1 = "לא ניתן לעדכן את הגעת הטכנאי";
        props.reportAnalytics({eventCategory: 'technician_update', eventAction: "visibility_9", eventLabel: "element_10"});
      break;
      case "TECHNICIAN_CANCEL_TIME_ERROR": //can't update visit Less then 24 hours
          title ="לא ניתן לבטל זימון זה באתר";
           explanation1 = "לא ניתן לבטל הגעת טכנאי בפחות מ24 שעות לפני הגעת הטכנאי";
           break;
      case "TECHNICIAN_CANCEL_GENERAL_ERROR": 
          title = "לא ניתן לבטל זימון זה באתר";
          explanation1 = "לא ניתן לבטל כרגע את הגעת טכנאי";
        break;
  }

    return (
        <Popup className="technician-updates-error-popup" showPopUp={props.errorPopup.isShow} onClose={() => {props.closeErrorPopup()}}>
            <h1>{title}</h1>
            <p>{explanation1}</p>
            {isMobile ?  <a href={`tel:${window.Config.technicalSupportPhone}`} >ניתן לפנות לנציג ב{window.Config.technicalSupportPhone}</a> : <p className='dial-info'>ניתן לפנות לנציג ב{window.Config.technicalSupportPhone}</p>}
            <div className="btn-wrapper">
                <BtnSubmit onclick={() =>props.closeErrorPopup()} text="סגור" formid="technician-update-callback-popup"></BtnSubmit>
            </div>
        </Popup>
    )
}

const mapStateToProps = (state) => {
    return {
      errorPopup: state.technicianUpdatesBlock.errorPopup,
    };
  };
  
  const mapDispatchToProps = {
    goToPage,
    reportAnalytics
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(ErrorPopUp);